<template>
  <footer class="employers-lt-footer  container">
    <div class="employers-lt-footer__content  container-inner">
      <p class="employers-lt-footer__copyright">
        {{ section.copyright }} {{ currentYear }} ©
      </p>
      <Socials :list="socialsChannels"
               :title="section.channels"
               class="employers-lt-footer__socials"/>
      <EmployersLTPageLocaleSelect :languages="section.languages.languages"
                                   class="employers-lt-footer__lang"/>
    </div>
  </footer>
</template>

<script>
  import Socials from "@/components/Socials";
  import EmployersLTPageLocaleSelect from "@/components/employersLTPage/common/EmployersLTPageLocaleSelect";

  export default {
    name: 'EmployersLTPageFooter',
    components: {
      Socials,
      EmployersLTPageLocaleSelect,
    },
    props: {
      section: Object
    },
    data() {
      return {
        socialsChannels: globalConfigs.footer.channels,
        currentYear: (new Date().getFullYear())
      }
    }
  }
</script>

<style lang="less">

</style>
